export const CONNECTED = 'CONNECTED';
export const DISCONNECTED = 'DISCONNECTED';
export const INCORRECT_DEVICE = 'INCORRECT_DEVICE';
export const WAITING_CONNECTION = 'WAITINGCONNECTION';
